import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return { button: css`
            ${custom.button};
            padding: 0;
        ` }
}

export default styles
